/* 上部の曜日リスト */
import * as React from 'react';

import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import { getElementByType, RETURN_FALSE } from '../utils/commonUtil';
import { Global } from '../utils/global';
import * as UserListField from '../constants/UserListField';

class DateList extends React.Component {
  // 頭文字フィルター用.
  // デフォルトはその曜日なのでそれでinexを取得する.
  weekSelected: string;
  // 各曜日の背景色が変化するElementの連想配列.
  refElements: { [key: string]: (HTMLElement | null); } = {};

  searchHeadWeek(e: React.MouseEvent<HTMLAnchorElement>, week: string) {
    // 背景変更.
    this.selectWeek(week, (e.target as HTMLElement).parentElement);

    this.weekSelected = week;

    // フィルター処理.
    this.filter();

    // ページ遷移防止.
    e.preventDefault();
    return false;
  }

  // フィルター処理.
  filter() {
    // userのオブジェクトの入ったhiddenのClass.
    let usersObject: HTMLCollectionOf<Element> = document.getElementsByClassName('user');

    // search枠.
    const searchText: HTMLInputElement | undefined = getElementByType('search');
    if (searchText) {
      // search枠のフィルター用文字列.
      const filterWord: string = searchText.value;

      if (filterWord) {
        // フィルターする(HTMLCollectionは配列に一回変換する必要あり).
        usersObject = [].slice.call(usersObject).filter(function(element: HTMLElement) {
          const parent: HTMLElement | null = element.parentElement;
          if (parent) {
            // 一旦全員消す(次の頭文字フィルターに委ねるため).
            parent.hidden = true;
          }

          const html: string = element.innerHTML;
          const row = JSON.parse(html);
          return Object.keys(row).some(function(key: string) {
            return String(row[key]).indexOf(filterWord) > -1;
          });
        });
      }
    }

    // ここから曜日フィルター.
    let index: number = 0;
    for (const key in usersObject) {
      if (usersObject.hasOwnProperty(key)) {
        // 1つのエレメント.
        const element: Element = usersObject[key];

        // stringfyで入ってるのでいったん変換.
        const userVisitDay: number[] = (JSON.parse(element.innerHTML) as UserListField.User).user_visit_day;

        const parent: HTMLElement | null = element.parentElement;
        // 選択されたWeekSelectedがWeekChars[]の中では何番目の値なのか？
        const weekIndex = UserListField.START_MO_WEEK_CHARS.indexOf(this.weekSelected);

        // 選択したのがAll or 1なら入ってる.
        if (this.weekSelected === UserListField.ALL || userVisitDay[weekIndex] === 1) {
          if (parent) {
            // 居る人は表示する.
            parent.hidden = false;

            // 偶数は白/奇数グレー(cssがhidden要素をスキップしてくれないので上書き).
            const isEven: boolean = index % 2 === 0;
            [].forEach.call(parent.childNodes, (child: Node) =>
              (child as HTMLElement).style.background = isEven ? '#fff' : '#e8e4df'
            );

            index++;
          }
        } else {
          if (parent) {
            // 該当しない人は消す.
            parent.hidden = true;
          }
        }
      }
    }
  }

  componentDidMount() {
    Global.kanaSerach = () => {
      // フィルター.
      this.filter();
    };

    // 最初にこれらの処理を行う.
    // 今日の曜日.
    const todayDay: string = UserListField.WEEK_CHARS[new Date().getDay()]; 

    // 背景変更.
    this.selectWeek(todayDay, this.refElements[todayDay]);

    // デフォルトはその曜日なのでそれでinexを取得する.
    this.weekSelected = todayDay;

    // フィルター処理.
    this.filter();
  }

  selectWeek(id: string, selectedDateBtn: HTMLElement | null) {
    if (selectedDateBtn === null) {
      return;
    }

    // 選択した曜日を表示/非選択表示に変更.
    if (selectedDateBtn.classList.contains('selected')) {
      // do something.
    } else {
      selectedDateBtn.classList.add('selected');
    }

    // 選択した曜日以外を非選択表示に変更.
    const eleList = document.querySelectorAll('ul.WeekList li');
    for (let i = 0; i < eleList.length; ++i) {
      if (eleList[i] !== selectedDateBtn) {
        eleList[i]
          .classList
          .remove('selected');
      }
    }
  }

  render() {
    return (
      <div className="header">
        <ul className="WeekList">
          <li ref={(item) => { this.refElements[UserListField.MO] = item; }}>
            <a
              onClick={event => this.searchHeadWeek(event, UserListField.MO)}
              href={RETURN_FALSE}
            >
              月
            </a>
          </li>
          <li ref={(item) => { this.refElements[UserListField.TU] = item; }}>
            <a
              onClick={event => this.searchHeadWeek(event, UserListField.TU)}
              href={RETURN_FALSE}
            >
              火
            </a>
          </li>
          <li ref={(item) => { this.refElements[UserListField.WE] = item; }}>
            <a
              onClick={event => this.searchHeadWeek(event, UserListField.WE)}
              href={RETURN_FALSE}
            >
              水
            </a>
          </li>
          <li ref={(item) => { this.refElements[UserListField.TH] = item; }}>
            <a
              onClick={event => this.searchHeadWeek(event, UserListField.TH)}
              href={RETURN_FALSE}
            >
              木
            </a>
          </li>
          <li ref={(item) => { this.refElements[UserListField.FR] = item; }}>
            <a
              onClick={event => this.searchHeadWeek(event, UserListField.FR)}
              href={RETURN_FALSE}
            >
              金
            </a>
          </li>
          <li ref={(item) => { this.refElements[UserListField.SA] = item; }}>
            <a
              onClick={event => this.searchHeadWeek(event, UserListField.SA)}
              href={RETURN_FALSE}
            >
              土
            </a>
          </li>
          <li ref={(item) => { this.refElements[UserListField.SU] = item; }}>
            <a
              onClick={event => this.searchHeadWeek(event, UserListField.SU)}
              href={RETURN_FALSE}
            >
              日
            </a>
          </li>
          <li ref={(item) => { this.refElements[UserListField.ALL] = item; }}>
            <a
              onClick={event => this.searchHeadWeek(event, UserListField.ALL)}
              href={RETURN_FALSE}
            >
              全て
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default DateList;



// WEBPACK FOOTER //
// ./src/components/DateList.tsx